import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken, getStoredToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    const token = getStoredToken();
    if (token) {
      setAuthToken(token);
      loadMe().finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setAuthToken(data.access_token);
    return loadMe();
  };

  const signup = async (payload) => {
    const { data } = await api.post("/auth/signup", payload);
    setAuthToken(data.access_token);
    return loadMe();
  };

  const logout = () => {
    setAuthToken(null);
    setUser(null);
    window.location.href = "/login";
  };

  const isOrgAdmin = user?.role === "ORG_ADMIN";
  const seesWholePortfolio = user?.role === "ORG_ADMIN" || user?.role === "PORTFOLIO_LEAD";

  return (
    <AuthContext.Provider
      value={{ user, loading, login, signup, logout, isOrgAdmin, seesWholePortfolio, refreshMe: loadMe }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
